import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/narzedzia/client/ToolsClient.tsx");
